import $ from 'jquery';

var Isotope = require('isotope-layout');


document.addEventListener("DOMContentLoaded", function () {
    // find element with data-isotope;
    const isotopeContent = document.querySelector('.js-wig-isotope');
    if (isotopeContent !== null) {
        const selector = isotopeContent.dataset.selector;
        const wrapper = document.querySelector(isotopeContent.dataset.wrapper);
        initIsotope(selector, wrapper);

        $iso.arrange(optsWig);
        // let $iso = null;

        // let allFilters = [];
        // gridFilterButtons.forEach(el=>{
        //     allFilters.push(el.dataset.category)
        // })

        // let optsWig = {
        //     itemSelector: '.wig',
        //     resize: false,
        //     transitionDuration: 'none',
        //     layoutMode: 'no-shuffle',
        //     hiddenStyle: {
        //         opacity: 0
        //     },
        //     visibleStyle: {
        //         opacity: 1
        //     },
        //     // filter: filters.join(','),
        //     // filter: '.test'
        //     filter: ':not(' + allFilters.join(',') + ')'
            
        // };
        // // console.log(optsWig.filter);
        // // $iso.arrange(optsWig);
        // console.log('buttons',gridFilterButtons,allFilters,':not(' + allFilters.join(',') + ')')   

    }

});




let filters = [];

let filterGroups = {
    user: [],
    color: [],
    types: [],
    sizes: [],
    lengths: []
}
// let notFilters = ['.barn', '.mann', '.kvinne'];
// let notFiltersOptions = ['.barn', '.mann', '.kvinne'];

let gridFilterButtons = document.querySelectorAll(".js-set-wig-filter");

// let allFilters = [];
// gridFilterButtons.forEach(el=>{
//     allFilters.push(el.dataset.category)
// })

let $iso = null;
let optsWig = {
    itemSelector: '.wig',
    resize: false,
    transitionDuration: 'none',
    layoutMode: 'no-shuffle',
    hiddenStyle: {
        opacity: 0
    },
    visibleStyle: {
        opacity: 1
    },
    filter: filters.join(','),
                // filter: ':not(' + allFilters.join(',') + ')'

};

const pushOrShove = (arr, val) => {
        

    let i = arr.indexOf(val);

    if (i === -1)
        arr.push(val);
    else
        arr.splice(i, 1);

        console.log('pushOr',arr,val)

    return arr;
}

function addOrRemove(array, value) {

    // // Handle :not filter options
    // if (notFiltersOptions.indexOf(value) !== -1) {
    //     // console.log('should add not filter', value)
    //     notFilters = pushOrShove(notFilters, value, true);
    // }
    // else
        // Handle normal filter options
        array = pushOrShove(array, value);
}

/*if (gridFilterButtons !== null) {
    gridFilterButtons.forEach((filterButton) => {
        filterButton.addEventListener("click", () => {

            var $this = $(filterButton);

            // get group key
            var $buttonGroup = $this.parents('.button-group');
            var filterGroup = $buttonGroup.attr('data-filter-group');
            // set filter for group
            filters[ filterGroup ] = $this.attr('data-filter');
            // combine filters
            var filterValue = concatValues( filters );
            
            console.log('spennende',buttonGroup,filterValue);

            $iso.arrange({ filter: filterValue });


            // addOrRemove(filters, filterButton.dataset.category);
            // addOrRemove(allFilters, filterButton.dataset.category);

            // let notClause = '';
            // let allFilters = filters.join(',');

            // if(notFilters.length < notFiltersOptions.length){
                
            //     notClause += ':not(' + notFilters.join(',') + ')';

            //     if(filters.length){
            //         let temp = filters.map((el)=> el + notClause);
            //         allFilters = temp.join(',');
            //     } else if (notFilters.length)
            //         allFilters = notClause;
            //     else 
            //         allFilters = '';
                
            // }
            // if(!filters.length)
            //     allFilters = '!*';

            // console.log('Applying filters:', ':not(' + allFilters.join(',') + ')');
                // filter: ':not(' + allFilters.join(',') + ')'

            // optsWig.filter = ':not(' + allFilters.join(',') + ')';
            // console.log('All filters: ', optsWig.filter);
            // $iso.arrange(optsWig);

        }
        );
    });
}*/

const initIsotope = (s, w) => {
    if (w !== null) {
        console.log('init',optsWig)
        $iso = new Isotope(w, {
            layoutMode: 'no-shuffle',
            ...optsWig,
        });
    }

    //   // layout mode that does not position items
    Isotope.LayoutMode.create('no-shuffle');

    function debounce(fn, threshold) {
        var timeout;
        threshold = threshold || 100;
        return function debounced() {
            clearTimeout(timeout);
            var args = arguments;
            var _this = this;
            function delayed() {
                fn.apply(_this, args);
            }
            timeout = setTimeout(delayed, threshold);
        };
    }

    Isotope.LayoutMode.create('no-shuffle');

    Isotope.prototype.arrange = function (props) {
        // console.log('I should be arranging',optsWig,props)
        // set any options pass
        this.option({
            ...optsWig,
            ...props
        });
        this._getIsInstant();
        // just filter
        this.filteredItems = this._filter(this.items);

        this.filteredItems.needHide.forEach((item) => {
            item.element.classList.add('is-hidden');
        });
        this.filteredItems.matches.forEach((item) => {
            item.element.classList.remove('is-hidden');
        });
        // flag for initalized
        this._isLayoutInited = true;
    };


}

$(document).ready(function () {

    $('.js-toggle-active').on('click', function (e) {
        $(this).toggleClass('is-active');
    })

    $('#wig-finder').on( 'click', '.button', function() {
        // console.log('im clicked')
        var $this = $(this);
        // get group key
        var $buttonGroup = $this.parents('.button-group');

        var filterGroup = $buttonGroup.attr('data-filter-group');

        console.log(filterGroups,$buttonGroup.attr('data-filter-group'),filterGroup);

        let nObj = Object.assign({},filterGroups,{
            [$buttonGroup.attr('data-filter-group')]: pushOrShove(filterGroups[$buttonGroup.attr('data-filter-group')],$this.attr('data-category')) 
        })

        console.log(nObj);
        let filterValue = cascadeValueObject(nObj);

        // set filter for group
        // filters[ filterGroup ] = $this.attr('data-category');
        // combine filters
        // var filterValue = concatValues( filters );
        // $grid.isotope({ filter: filterValue });

        console.log(filterValue)
        $iso.arrange({ filter: filterValue });

      });

});

    // flatten object by concatting values
    function concatValues( obj ) {
        var value = '';
        for ( var prop in obj ) {
            value += obj[ prop ];
        }
        return value;
    }

    const cascadeValueObject = ( obj ) => {
        // let v = '';

        let strings = [];
        // let filters = [];
        // let temp = [];

        // if(obj.user){
        //     // console.log(obj.user)
        //     for(let i in obj.user){
        //         console.log('should push ', obj.user[i])
        //         strings.push(obj.user[i])
        //     }
        //     // obj.user.forEach(el=>strings.push(el))
        // }

        // if(obj.user){
        //     if(!strings.length){
        //         for(let i in obj.user){
        //             strings.push(obj.user[i])
        //         }
        //     }
        //     else {
        //         temp = []
        //         obj.user.forEach(el => {
        //             strings.forEach((string)=>{
        //                 temp.push(string + el)
        //             })
        //         })
        //         strings = temp;
        //     }
        // }

        for(let group in obj){
            // console.log('group moogi', obj[group]);
            strings = handleGroup(strings, obj[group]);
        }

        // strings = handleGroup(strings, obj.user);
        
        // console.log('early strings',strings)

        // if(obj.color.length){
        //     temp = []
        //     obj.color.forEach(el => {
        //         strings.forEach((string)=>{
        //             temp.push(string + el)
        //         })
        //     })
        //     strings = temp;
        // }

        // if(obj.types.length){
        //     temp = []
        //     obj.types.forEach(el => {
        //         strings.forEach((string)=>{
        //             temp.push(string + el)
        //         })
        //     })
        //     strings = temp;
        // }

        // if(obj.sizes.length){
        //     temp = []
        //     obj.sizes.forEach(el => {
        //         strings.forEach((string)=>{
        //             temp.push(string + el)
        //         })
        //     })
        //     strings = temp;
        // }

        // if(obj.lengths.length){
        //     temp = []
        //     obj.lengths.forEach(el => {
        //         strings.forEach((string)=>{
        //             temp.push(string + el)
        //         })
        //     })
        //     strings = temp;
        // }



        console.log('strings',strings);

        // // Look for user 
        // for (let i in obj){
            
        //     if(obj[i].length){
        //         console.log(i,obj[i]);
        //         strings.push(obj[i]);
                
        //     }
        // }

        // for(let i = 0; i < strings.length; i++){

        //     console.log('strings',strings[i])

        // //     let t = '';
        //     for(let j = 0; j < strings[i].length; j++){
        // //         console.log('inside strings',strings[i][j])
        // //         t += strings[i][j];
        //         filters[j] = filters[j] + strings[i][j];
        //     }
        
            
        // }

        // console.log(filters)
        // // for( let i = 0; i < obj.length; i++){
        // //     console.log('hei',i)
        // // }

        return strings.join(', ');
    }

    const handleGroup = (strings, group) => {

        if(!group.length)
            return strings;

        if(group){
            if(!strings.length){
                for(let i in group){
                    strings.push(group[i])
                }
            }
            else {
                let temp = []
                group.forEach(el => {
                    strings.forEach((string)=>{
                        temp.push(string + el)
                    })
                })
                strings = temp;
            }
        }

        return strings;
    }